<template>
  <div
    class="profile-actions profile-actions--footer"
    data-test-id="manage-bosch-id-section"
  >
    <h2 class="form__title">
      {{ $t('myaccount.data-act.header') }}
    </h2>
    <p class="lead-settings" v-html="$t('myaccount.data-act.link', {})"></p>
  </div>
</template>

<script>
  export default {
    name: 'user-euda-link',
  };
</script>

<style scoped>
  .lead-settings {
    float: left;
    width: 100%;
    margin-bottom: 3rem;
    text-align: left;
  }

  .lead-settings strong {
    font-weight: 500;
  }

  .cta-wrapper {
    width: 100%;
    float: left;
  }

  .button {
    color: #2D2D37 !important;
  }

  .button:hover,
  .button:focus {
    color: white !important;
    background-color: #2D2D37 !important;
    border: 1.5px solid #2D2D37 !important;
  }
</style>
